import PropTypes from 'prop-types';
import { Component } from 'react';

export default class AdvisoryToolView extends Component {

  /* Render */

  render() {
    return this.props.children;
  }
}

AdvisoryToolView.propTypes = {
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./js/views/advisory-tool/index.jsx